import React from 'react'

import styles from './RequiredBadge.module.css'

type Props = {
  dataDgId?: string
}

export const RequiredBadge = ({ dataDgId }: Props) => (
  <span className={styles.badge} data-dg-id={dataDgId}>
    必須
  </span>
)
